import React from "react";
import { Box, Typography } from "@mui/material";

import { colorSchemes, fontSizeSchemes } from "../../assets/commonFunction";
import TaskCard from "../TaskCard/TaskCard";

const SubTaskCard = ({
  taskItem,
  subTaskItem,
  setStartTaskOpen,
  handleStartTask,
  indx,
  handleClickTaskUpdate,
  handleViewThreadClick,
  tabValue,
  taskTabValue,
  userData,
  groupList,
  taskStatusLabels,
  onDragStart,
  subIndex,
  onDragEnd,
  isDragging,
  draggedTask,
  setProfileViewModal,
  isProfileViewOpen,
  profileViewData,
  setProfileViewData,
  handleShowUserProfile,
  startTaskOpen,
  recipientDetails
}) => {


  return (
    <Box
      width="100%"
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginLeft: "0.5rem",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginRight: "0.2rem",
        }}
      >
        {/* Vertical Subtask Text */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100px",
            writingMode: "vertical-rl",
            textOrientation: "mixed",
            marginLeft: "0.2rem",
          }}
        >
          <Typography
            sx={{
              transform: "rotate(180deg)",
              fontSize: fontSizeSchemes.font16,
              fontWeight: 400,
              color: colorSchemes.black,
              textTransform: "none",
              marginRight: "0.4rem",
            }}
          >
            SubTask
          </Typography>
        </Box>

        {/* Drag Handle */}
        <Box
          sx={{
            cursor: "grab",
            borderRadius: "4px",
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.05)",
              transform: "scale(1.1)",
            },
            "&:active": {
              cursor: "grabbing",
              transform: "scale(0.95)",
            },
          }}
        >
          {/* <img
            src={drag_icon}
            alt="Drag to reorder"
            style={{
              width: "17px",
              height: "32px",
              transition: "opacity 0.2s ease",
              filter: "brightness(0.7)",
              marginRight: "0.6rem",
              marginLeft: "0.5rem",
            }}
            onMouseEnter={(e) => {
              e.target.style.opacity = "1";
              e.target.style.filter = "brightness(1)";
            }}
            onMouseLeave={(e) => {
              e.target.style.opacity = "0.7";
              e.target.style.filter = "brightness(0.7)";
            }}
          /> */}
        </Box>
      </Box>

      {/* Subtasks Container */}
      <Box
        sx={{
          flex: 1,
          border: "1px solid rgba(0, 0, 0, 0.1)",
          borderRadius: "19.5px",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
          padding: "9px 20px 9px 12px",
          // backgroundColor:
          //   subIndex % 2 === 0 ? "rgba(222, 222, 222, 1)" : "#fffefeff",
          transition: "background-color 0.3s ease",
        }}
      >
        <TaskCard
          taskItem={taskItem}
          setStartTaskOpen={setStartTaskOpen}
          handleStartTask={handleStartTask}
          indx={indx}
          handleClickTaskUpdate={handleClickTaskUpdate}
          handleViewThreadClick={handleViewThreadClick}
          tabValue={tabValue}
          taskTabValue={taskTabValue}
          userData={userData}
          groupList={groupList}
          taskStatusLabels={taskStatusLabels}
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
          isDragging={isDragging && draggedTask?.id === taskItem?.id}
          setProfileViewModal={setProfileViewModal}
          isProfileViewOpen={isProfileViewOpen}
          profileViewData={profileViewData}
          setProfileViewData={setProfileViewData}
          handleShowUserProfile={handleShowUserProfile}
          startTaskOpen={startTaskOpen}
          recipientDetails={recipientDetails}
        />
      </Box>
    </Box>
  );
};

export default SubTaskCard;
